(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/index.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/index.js');
"use strict";

const Router = svs.tickets_giftshop.Router;
const target = document.getElementById('react-container');
target && ReactDOM.render(React.createElement(Router, null), target);

 })(window);